import React, { useState } from "react";
import { BarChart, BarChartProps } from "../BarChart";
import { PieChart } from "../PieChart";
import { Accordion } from "oolib/dist/v2/components/Accordion";
// Type for the chart options configuration
type ChartOptionConfig = {
  display: string;
  comp: 'PieChart' | 'BarChart';
  props: BarChartProps;  // Removed Partial and ? - props are now required with their original requirements
};

type ChartComponents = {
  [K in ChartOptionConfig['comp']]: {
    comp: React.ComponentType<any>;
    wrapperStyle?: React.CSSProperties;
  };
};

interface DataVizAccordionProps extends BarChartProps {
  title?: string;
  chartOptions: ChartOptionConfig[];
}

export const DataVizAccordion: React.FC<DataVizAccordionProps> = ({
  title,
  chartOptions = [],
  ...props
}) => {
  const ChartComps: ChartComponents = {
    PieChart: {
      comp: PieChart,
      wrapperStyle: {}
    },
    BarChart: {
      comp: BarChart,
      wrapperStyle: { padding: "0 1rem 0.6rem 1rem" }
    },
  };

  const [activeCompConfig, setActiveCompConfig] = useState<ChartOptionConfig>(chartOptions[0]);

  const genActiveChartComp = (activeCompConfig: ChartOptionConfig) => {
    const ActiveChartComp = ChartComps[activeCompConfig.comp].comp;
    const wrapperStyle = ChartComps[activeCompConfig.comp].wrapperStyle;

    return (
      <div style={{
        padding: "0 1.6rem 1rem 1.6rem",
        ...(wrapperStyle || {}),
      }}>
        <ActiveChartComp {...props} {...activeCompConfig.props} />
      </div>
    );
  };

  

  return (
    <Accordion
      key={JSON.stringify(activeCompConfig)}
      title={title}
      actionsConfig={chartOptions.length > 1 && chartOptions.map((d) => ({
        display: d.display,
        onClick: () =>
          setActiveCompConfig(d),
      }))}
    >
      {genActiveChartComp(activeCompConfig)}
    </Accordion>
  );
};